import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../appbar/AppBar.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { MdArrowOutward, MdClose } from "react-icons/md";
import { BsLightningFill } from "react-icons/bs";
import Button from "react-bootstrap/Button";
import Buttons from "../../components/button/Buttons";
import menuItems from "../../routes/routes";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
const AppBar = () => {
  const navigate = useNavigate();
  const handleContact = () => {
    navigate("/contactus");
  };
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  const toggleNavbar = () => setExpanded(!expanded);
  const closeNavbar = () => setExpanded(false);

  const logoVariants = {
    initial: { y: 0 },
    hover: { y: -2 }
  };

  const letterVariants = {
    initial: { opacity: 0, y: 10, filter: "blur(5px)" },
    animate: (i) => ({
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { delay: i * 0.05, duration: 0.5, ease: "easeOut" }
    }),
    hover: {
      y: -5,
      color: "#27ae60",
      transition: { duration: 0.2 }
    }
  };

  return (
    <Navbar expand="lg" className="nav-bg" expanded={expanded}>
      <Container fluid className="px-md-5">
        <Navbar.Brand as={Link} to="/" className="brand_identity_stage me-auto">
          <motion.div
            className="logo_wrapper"
            initial="initial"
            animate="animate"
            whileHover="hover"
          >
            {/* Animated Brand Name */}
            <div className="brand_name_container">
              {"Zentexus".split("").map((char, i) => (
                <motion.span
                  key={i}
                  custom={i}
                  variants={letterVariants}
                  className={char === 'Z' ? 'z_initial' : 'brand_char'}
                >
                  {char}
                </motion.span>
              ))}
            </div>


          </motion.div>
        </Navbar.Brand>
        <Button className="menu-toggle" id="menu-toggle" onClick={toggleNavbar} aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </Button>
        <Navbar.Collapse
          id="nav-bar"
          className={`justify-content-end custom-collapse ${expanded ? "open" : ""
            }`}
        >
          <Nav className="mx-auto">
            {menuItems
              .filter(item => !["/terms", "/privacy", "/refund"].includes(item.path))
              .map((item) => (
                <Nav.Link
                  key={item.path}
                  as={Link}
                  to={item.path}
                  className={`
                  ${location.pathname === item.path ? "active" : ""} 
                  ${item.path === "/buildx-challenge" ? "highlighted-nav-link" : ""}
                `}
                  onClick={(e) => {
                    if (item.path === "/buildx-challenge") {
                      e.preventDefault();
                      window.dispatchEvent(new CustomEvent("openBuildXAbout"));
                    }
                    closeNavbar();
                  }}
                >
                  {item.path === "/buildx-challenge" && <BsLightningFill className="me-1" />}
                  {item.label}
                </Nav.Link>
              ))}
          </Nav>

        </Navbar.Collapse>
        <div className="d-lg-block d-none">
          <Buttons
            label={
              <span className="btn_content">
                Let's Talk
                <MdArrowOutward className="arrow_icon" />
              </span>
            }
            className="talk_premium_btn"
            onclick={handleContact}
          />
        </div>
      </Container>
    </Navbar>
  );
};

export default AppBar;
